import React, { useState } from 'react'
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import { About, Footer, Home, Work, Works, Contact } from './container';
import { Navbar } from './components'
import './App.scss'

const App = () => {
  const [darkmode, setDarkmode] = useState(false);
  const [page, setPage] = useState('home');

  return (
    // <div className="app">
    //     <Navbar DarkMode = {darkmode} SetDarkMode = {setDarkmode}/>
    //     <Home DarkMode = {darkmode} SetDarkMode = {setDarkmode}/>
    //     <About DarkMode = {darkmode} SetDarkMode = {setDarkmode}/>
    //     <Work DarkMode = {darkmode} SetDarkMode = {setDarkmode}/>
    //     <Skills DarkMode = {darkmode} SetDarkMode = {setDarkmode}/>
    //     <Footer DarkMode = {darkmode} SetDarkMode = {setDarkmode}/>
    // </div>

    <Router>
      <Navbar DarkMode = {darkmode} SetDarkMode = {setDarkmode} Page={page} SetPage={setPage}/>
      <Routes>
        <Route path='/' element={<><Home DarkMode = {darkmode} SetDarkMode = {setDarkmode} Page={page} SetPage={setPage}/><Footer/></>}/>
        <Route path='/about' element={<><About DarkMode = {darkmode} SetDarkMode = {setDarkmode} Page={page} SetPage={setPage}/><Footer/></>}/>
        <Route path='/work' element={<><Work DarkMode = {darkmode} SetDarkMode = {setDarkmode} Page={page} SetPage={setPage}/><Footer/></>}/>
        <Route path='/work/:workId' element={<Works DarkMode = {darkmode} SetDarkMode = {setDarkmode} Page={page} SetPage={setPage}/>}/>
        <Route path='/contact' element={<Contact DarkMode = {darkmode} SetDarkMode = {setDarkmode} Page={page} SetPage={setPage}/>}/>
      </Routes>
    </Router>
  );
}

export default App